module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name !== 'Plano') ? _c('footer', {
    staticClass: "jc-fe",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "row m-0 flexContainer ai-c footer-container"
  }, [_c('div', {
    staticClass: "versionings col-12 col-sm-auto flexContainer jc-c justify-content-sm-start",
    on: {
      "click": _vm.versioning
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.versioning")))])]), _vm._v(" "), _c('div', {
    staticClass: "versionings col-12 col-sm-auto flexContainer jc-c justify-content-sm-start",
    on: {
      "click": function($event) {
        _vm.showCGUModal();
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("cguModal.acronyme")))])]), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('div', {
    staticClass: "adminTools col-12 col-sm-auto justify-content-center flexContainer justify-content-sm-start",
    on: {
      "click": function($event) {
        _vm.adminTools();
      }
    }
  }, [_c('span', [_vm._v("SuperAdmin Tools")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "version col-12 col-sm flexContainer justify-content-center justify-content-sm-end"
  }, [_c('span', [_vm._v(_vm._s(_vm.rem3rchVersion) + " " + _vm._s(_vm.$t("common.footerDate")))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53dbabf5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Footer.vue
// module id = 3187
// module chunks = 0